// Port of api/fuel/app/classes/filter/search/games/filters/query/collection/worth/play.php
import { rangeActive } from 'offline/filter/core/search/unit'

export default {
	name: 'collection.worth.play',
	priority: 89,
	require: function(config, filter) {
		return rangeActive(filter.worth && filter.worth.play, 0, 200)
	},
	run: function(config, filter, data, query) {
		query.select('c.collection_value / c.collection_plays', 'avg_play')
		query.where('c.collection_plays', '>', 0)
		if (filter.worth.play.from > 0) {
			query.where('avg_play', '>=', filter.worth.play.from)
		}
		if (filter.worth.play.to < 200) {
			query.where('avg_play', '<=', filter.worth.play.to)
		}
	}
}
